import { service } from '../../../../helpers/http'

export const ActionUpdateActivityItemsApprovals = ({ dispatch }, payload) => {
    
    return service({
        module: 'activityItem',
        action: 'activityItemsApprovals',
        payload: payload,
    });
}